import { Stack, Typography } from '@mui/material';

import { formatNumberByThousands } from '@/helpers/format.helpers';

type ContentTotalAmountProps = {
  cashbackSum: number;
};

export const ContentTotalAmount = (props: ContentTotalAmountProps) => (
  <Typography component={Stack} variant="h3" direction="row" spacing={1}>
    <Typography component="span" variant="inherit">
      {formatNumberByThousands(props.cashbackSum)}
    </Typography>
    <Typography component="span" variant="inherit" fontWeight={400}>
      UZS
    </Typography>
  </Typography>
);
